import React, { PropTypes } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Well, Button } from 'react-bootstrap';
import renderField from '../../FormTemplate/InputControl';

class NewShopForm extends React.Component {

   constructor(props) {
      super(props);
   }

   render() {
      const { saveShop, handleSubmit } = this.props; //eslint-disable-line react/prop-types
      return (<Well>
            <form noValidate autoComplete="off" onSubmit={handleSubmit(saveShop)} >
               <Field name="name" component={renderField} type="text" placeholder="Shop Name" label="Shop Name" />
               <Button type="submit" >Save</Button>
            </form>
         </Well>
      );
   }
}

NewShopForm.propTypes = {
   saveShop: PropTypes.func.isRequired
};

export default reduxForm({
   form: 'newShopForm'
})(NewShopForm);



/** WEBPACK FOOTER **
 ** ./src/components/ShopManagement/Shop/NewShopForm.js
 **/